
import { Card, Space, Table, Col, Flex } from 'antd';
import UpdateCurrencyModal from './UpdateCurrencyModal';
import RegisterCurrenciesModal from './RegisterCurrenciesModal';
import { useSelector, useDispatch } from 'react-redux';
import { getCurrenciesCountAsync, selectCurrencies, selectCurrencyCount, selectCurrencyFilterOptions } from '../../../app/store/reducers/currency/currencyReducer';
import { getCurrenciesAsync } from './../../../app/store/reducers/currency/currencyReducer';
import { useEffect } from 'react';



const Currencies = () => {
  const filter = useSelector(selectCurrencyFilterOptions)
  const count = useSelector(selectCurrencyCount)
  const currencies = useSelector(selectCurrencies)
  const dispatch = useDispatch()

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: true,
      render: (name) => <a>{name}</a>,
    },
    {
      title: 'Amount',
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          <a>{record.amount}</a>
        </Space>
      ),
    },
    {
      title: 'operation',
      dataIndex: 'operation',
      render: (_, record) =>{
        return (
          <UpdateCurrencyModal currency={record} />
        )
      }
    },
  ];
  const data = [
    {
      key: '1',
      name: 'John Brown',
      age: 32,
      address: 'New York No. 1 Lake Park',
      tags: ['nice', 'developer'],
    },
    {
      key: '2',
      name: 'Jim Green',
      age: 42,
      address: 'London No. 1 Lake Park',
      tags: ['loser'],
    },
    {
      key: '3',
      name: 'Joe Black',
      age: 32,
      address: 'Sydney No. 1 Lake Park',
      tags: ['cool', 'teacher'],
    },
  ];


    useEffect(() => {
    dispatch(getCurrenciesAsync({...filter}))
    dispatch(getCurrenciesCountAsync({...filter}))
  },[filter])


  const handleTableChange = (pagination, filters, sorter) => {
    console.log("table", pagination, filters, sorter)
    // setTableParams({
    //   pagination,
    //   filters,
    //   ...sorter,
    // });

    // `dataSource` is useless since `pageSize` changed
    // if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      // setData([]);
    // }
  };


    return (
    <>
        <Card>
          <Flex align="center" justify="space-between" style={{borderBottom: "2px solid green"}}>
            <Col>
            <h4>Currencies</h4>
            </Col>
            <Col>
              <RegisterCurrenciesModal/>
            </Col>
          </Flex>
        <Table
          columns={columns} 
          dataSource={currencies} 
          pagination={{
            current: filter.page,
            pageSize: filter.limit,
            total: count,
          }} 
          scroll={{
            // y: 240,
          }}
          onChange={handleTableChange}
          />
        </Card>
    </>
  )
}

export default Currencies